export const getPreviousPageUrl = ({
  navigations: {
    previous
  }
}) => previous
